import { omit } from "lodash";
import { FC, type MouseEvent, ReactNode } from "react";
import { useHistory } from "react-router";

import { Button, ButtonProps } from "@livechat/design-system-react-components";

type BaseLinkProps = {
  action?: "back" | "forward";
  children: ReactNode;
} & ButtonProps;

type ToLinkProps = {
  to: string;
  action?: "push" | "replace";
  children?: ReactNode;
} & ButtonProps;

type LinkProps = BaseLinkProps | ToLinkProps;

export const StyledLink: FC<LinkProps> = ({ action = "push", children, onClick, ...props }) => {
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = (event: MouseEvent<HTMLButtonElement> & MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    switch (action) {
      case "push":
        history.push((props as ToLinkProps).to);
        break;
      case "replace":
        history.replace((props as ToLinkProps).to);
        break;
      case "back":
        history.goBack();
        break;
      case "forward":
        history.goForward();
        break;
      default:
        break;
    }
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onClick && onClick(event);
  };

  const rest = omit(props, ["to"]);

  return (
    <Button href={(props as ToLinkProps).to} type="button" kind="link-light" onClick={handleClick} {...rest}>
      {children}
    </Button>
  );
};
